'use strict';

export default angular.module('contartemx.preferencias.perfil', [
	'ui.router',
	'floatingDiv',
	'validationBubble'
])
.controller('PerfilCtrl',($scope, $state, $uibModal, callToWebService, mostrarNotificacion, onboarding, apiCall) => {
    $scope.loadingMsg = 'Cargando...';
    $scope.load = true;

  const ContarteAPI = new apiCall($scope);

	$scope.showInactiveIncome = false;
  ContarteAPI.post('ObtenerPantallaPerfil', {})
  .then(data => {
			if(data.Respuesta && data.CodigoRespuesta !== 500)
			{
				$scope.direccion = data.Respuesta.Direccion;
				$scope.monedas = data.Respuesta.Monedas;
				$scope.persona = data.Respuesta.Persona;
				
				$scope.sucursales = data.Respuesta.Sucursales;
				$scope.tiposIngreso = data.Respuesta.TiposDeIngreso;
				$scope.zonasHorarias = data.Respuesta.ZonasHorarias;
				$scope.paises = data.Respuesta.Paises;
				$scope.estados = data.Respuesta.Estados;
				$scope.monedaRegion = data.Respuesta.ClaveMoneda;
				$scope.zonaHorariaRegion = data.Respuesta.ClaveZonaHoraria;
			}
			else
			{
				mostrarNotificacion.error('Ocurrio un error al cargar los datos');
			}
		},
		error => {
			mostrarNotificacion.error('Ocurrio un error al cargar los datos');
		});

	$scope.toggleTipoPersona = function(val){
		$scope.persona.EsMoral = val;
	};

	$scope.alert = [];

	$scope.saveProfileInfo = function(){
		
		$scope.loadingMsg = 'Guardando cambios..';

		if($scope.formPerfil.$valid)
		{
			var profileInfo = {
					perfil: {
						DatosPersona:$scope.persona,
						DatosDireccion:$scope.direccion,
						ClaveMoneda: $scope.monedaRegion,
						TiposDeIngreso: $scope.tiposIngreso,
						ClaveZonaHoraria: $scope.zonaHorariaRegion
					}
            };

        $scope.loading = true;

				callToWebService.postCall('GuardarPantallaPerfil', profileInfo,
					function success(data){
						if(data.Respuesta && data.CodigoRespuesta !== 500)
						{
							for(var i=0;i<$scope.sucursales.length;i++)
							{
								if($scope.sucursales[i].EsMatriz)
								{
									$scope.sucursales[i].Calle = data.Respuesta.Direccion.Calle;
									$scope.sucursales[i].Ciudad = data.Respuesta.Direccion.Ciudad;
									$scope.sucursales[i].CodigoPostal = data.Respuesta.Direccion.CodigoPostal;
									$scope.sucursales[i].Colonia = data.Respuesta.Direccion.Colonia;
									$scope.sucursales[i].CveEstado = data.Respuesta.Direccion.CveEstado;
									$scope.sucursales[i].CvePais = data.Respuesta.Direccion.CvePais;
									$scope.sucursales[i].NumeroExterior = data.Respuesta.Direccion.Numero;
									$scope.sucursales[i].NumeroInterior = data.Respuesta.Direccion.NumeroInterior;
									$scope.sucursales[i].Telefono = data.Respuesta.Direccion.Telefono;
									break;
								}
							}
							$scope.loading = false;
							mostrarNotificacion.info('La informacion del perfil se guardo correctamente');
							$scope.$parent.loadUserData();
							//$scope.enviarCorreoRFC();

							$scope.$emit('nextOnboardingStep', 'preferencias.impuestos');
						}
						else
						{
							$scope.loading = false;
							mostrarNotificacion.error(data.Mensaje);
						}
					},
					function error(data){
						$scope.loading = false;
						mostrarNotificacion.error(data.Mensaje);
					});
				
		}
		else
		{
			$scope.load = false;
			if ($scope.formPerfil.RFCempresa)
			{
				if($scope.formPerfil.RFCempresa.$invalid)
				{
					mostrarNotificacion.error("El RFC de la empresa no es valido!");
				}
				else {
					mostrarNotificacion.error('Faltan datos! Ingresa los datos donde aparece el simbolo azul');
				}
			}
			else if($scope.formPerfil.RFCpersona)
			{
				if($scope.formPerfil.RFCpersona.$invalid)
				{
					$scope.alert = [];
					mostrarNotificacion.error("El RFC de la persona no es valido!");
				}
				else {
					mostrarNotificacion.error('Faltan datos! Ingresa los datos donde aparece el simbolo azul');
				}
			}
		}
	};

	$scope.closeAlert = function(){
		$scope.alert = [];
	};

	$scope.$watch('direccion.CvePais', function(newVal, oldVal){
		if (oldVal) {
			callToWebService.postCall('ObtenerEstadosPorPais', {cvePais: newVal},
				function sucess(data){
					$scope.estados = data.ListaRespuestas;
				},
				function error(data){

				});
			}
	}, true);
    //---------------- enviarcorreorfc
	$scope.enviarCorreoRFC = function () {
	    var data = { CveContribuyente: $scope.userInfo.ClaveContribuyente, subject: "Perfil Actualizado" };
	    callToWebService.postCall('EnviarCorreoTimbresMembresias', data, function success(data) {
	        if (data.EsError) {
	            //mostrarNotificacion.error("Hubo un error al mandar la petición");
	        }
	    }, function error(data) {
	        //console.log("Hubo un error al mandar la petición");
	    });
	}

	// -------- MODAL SUCURSALES
	$scope.displayPopupSucursales = function ( sucursalSelec) {
		$scope.sucursalSeleccionada = $scope.sucursales[sucursalSelec];
		var modalInstance = $uibModal.open({
      template: require('../../../../../app/views/Preferencias/Perfil/Sucursal_modal.html'),
			controller: SucursalNuevoCtrl,
			windowClass: 'modal--small',
			resolve: {
				paises: function () {
					return $scope.paises;
				},
				sucursales: function () {
					return $scope.sucursalSeleccionada;
				},
				estados: function(){
					return $scope.estados;
				}
			}
		});

		modalInstance.result.then(function (result) {
		if(result!==null)
		{
			if(result.add)
			{
				if(result.sucursal.EsMatriz)
				{
					$scope.direccion = result.sucursal.Direccion;
					for(var i=0;i<$scope.sucursales.length;i++)
					{
						if($scope.sucursales[i].EsMatriz)
						{
							$scope.sucursales[i].EsMatriz = false;
						}
					}
				}

				$scope.sucursales.push(result.sucursal);
			}
			else
			{
				var i = $scope.sucursales.length;

				while(i>0)
				{
					i--;
					if($scope.sucursales[i].CveSucursal == result.sucursal.CveSucursal)
					{
						if(result.edit)
						{
							if(result.sucursal.EsMatriz)
							{
								$scope.direccion = result.sucursal.Direccion;
								for(var e=0;e<$scope.sucursales.length;e++)
								{
									if($scope.sucursales[e].EsMatriz)
									{
										$scope.sucursales[e].EsMatriz = false;
									}
								}
							}
							$scope.sucursales.splice(i,1, result.sucursal);
						}
						else
						{
							$scope.sucursales.splice(i,1);
						}
					}
				}
			}

			mostrarNotificacion.info(result.mensaje);
		}
			
		});
	};

	var SucursalNuevoCtrl = function ($scope, $uibModalInstance, $http, paises, sucursales, estados) {
		
		$scope.switchWindow = function (v, form) {
			if(v)
			{
				$scope.sucursaltipo = false;
			}
			else
			{
				$scope.sucursaltipo = true;
			}
		};

		$scope.sucursaltipo=true;
		$scope.paisesList = angular.copy(paises);
		$scope.Estados = angular.copy(estados);
		$scope.estado={};
		
		if (sucursales)
		{
			$scope.sucursaltipo = !sucursales.EsMatriz;
			$scope.Nombre=sucursales.Nombre; 
			$scope.Calle=sucursales.Calle;
			$scope.NumeroExterior=sucursales.NumeroExterior;
			$scope.NumeroInterior=sucursales.NumeroInterior;
			$scope.Colonia=sucursales.Colonia;
			$scope.Ciudad=sucursales.Ciudad;
			$scope.CodigoPostal=sucursales.CodigoPostal;
			for(var i=0; i<$scope.paisesList.length; i++)
			{
				if($scope.paisesList[i].CvePais==sucursales.CvePais)
				{
					
					$scope.pais = $scope.paisesList[i];
					break;
				}
			}
		}

		$scope.$watch('paisesList', function (newValue, oldValue) {
			
			if(angular.isUndefined($scope.pais)){
				var mexico = 'México';
				if (newValue) {
					var i = $scope.paisesList.length;
					while (i > 0) {
						i--
						if ($scope.paisesList[i].Nombre == mexico) {
							$scope.pais = $scope.paisesList[i];
							$scope.estado = $scope.Estados[0];
							break;
						}
					}
				}
			}
		}, true);

		$scope.selecPais = function (pais) {
			
			var i = $scope.paisesList.length;
			while (i > 0) {
				i--
				if ($scope.paisesList[i].Nombre == pais) {
					$scope.pais = $scope.paisesList[i];
					break;
				}
			}
		};

		$scope.selecEstado = function (estado) {
			
			var i = $scope.Estados.length;
			
			while (i > 0) {
				i--
				if ($scope.Estados[i].CveEstado == estado) {
					$scope.estado = $scope.Estados[i];
					break;
				}
			}
		}

		$scope.addSucursal = function (form) {
		
			var sucursal = {};
			if (form.$valid) {
				sucursal.EsMatriz = !$scope.sucursaltipo;
				sucursal.Nombre = form.Nombre.$viewValue;
				sucursal.Calle = form.Calle.$viewValue;
				sucursal.NumeroExterior = form.NumeroExterior.$viewValue;
				sucursal.NumeroInterior = form.NumeroInterior.$viewValue;
				sucursal.Colonia = form.Colonia.$viewValue;
				sucursal.Ciudad=form.Ciudad.$viewValue;
				sucursal.CodigoPostal = form.CodigoPostal.$viewValue;
				sucursal.CveEstado=form.Estado.$viewValue.CveEstado;
				sucursal.CvePais=form.Pais.$viewValue.CvePais;
				if(sucursales)
				{
					sucursal.CveSucursal = sucursales.CveSucursal;
				}

				callToWebService.postCall('CrearEditarSucursal',{sucursal:sucursal},
					function success(data){
						
						if (data && data.CodigoRespuesta) {
							if (data.CodigoRespuesta != 500) {
								$uibModalInstance.close({mensaje:data.Mensaje, sucursal:data.Respuesta, add:(!sucursal.CveSucursal),edit:(sucursal.CveSucursal !== null)});
							} else {
								$scope.alert = [];
								$scope.alert.push({ type: 'error', msg: data.Mensaje });
							}
						} else {
							$scope.alert = [];
							$scope.alert.push({ type: 'error', msg: data.Mensaje});
						}
					},
					function error(data){
						$scope.alert = [];
						$scope.alert.push({ type: 'error', msg: data.Mensaje});
					});
			}
			else
			{
				$scope.alert = [];
				$scope.alert.push({ type: 'error', msg: 'Faltan datos! Ingresa los datos donde aparece el simbolo azul' });
			}
		};

		$scope.$watch('pais', function (newValue, oldValue) {
			
			if (newValue !== '')
			{
				callToWebService.postCall('ObtenerEstadosPorPais', {cvePais:newValue.CvePais},
					function success(data){
						
						if(data.CodigoRespuesta !== 500)
						{
							$scope.Estados = data.ListaRespuestas;
							if(sucursales)
							{
								$scope.selecEstado(sucursales.CveEstado);
							}
							else
							{
								if($scope.pais.Nombre=="México")
								{
									$scope.selecEstado($scope.estado.CveEstado);
								}
							}
						}
						
					},
					function error(data){
						mostrarNotificacion.error('Ocurrio un error al obtener información');
					});
			}
		});

		$scope.deleteSucursal = function(){
			callToWebService.postCall('DesactivarSucursal', {cveSucursal: sucursales.CveSucursal},
				function success(data){
					
					if(data.Respuesta && !data.EsError)
					{
						$uibModalInstance.close({mensaje:data.Mensaje, sucursal:sucursales, add:false});
					}
					else
					{
						$scope.alert = [];
						$scope.alert.push({ type: 'error', msg: data.Mensaje });
					}
				},
				function error(data){
					$scope.alert = [];
					$scope.alert.push({ type: 'error', msg: data.Mensaje });
				});
		};

		$scope.closeModalAlert = function (i) {
			$scope.alert.splice(i, 1);
		};

		$scope.closeClienteModal = function (respuesta) {
			$uibModalInstance.close(null);
		};
	};
	// fin modal

});
